var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityMapSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2067 4.9L16.6667 6.62667V9.33334H15.3333V6.86L9.33332 3.78667V6H7.99999V3.51334L1.55332 6.18C1.48941 6.20603 1.43451 6.2502 1.39542 6.30707C1.35632 6.36394 1.33473 6.43101 1.33332 6.5V20.3C1.33295 20.3587 1.34722 20.4166 1.37485 20.4685C1.40248 20.5203 1.4426 20.5644 1.49157 20.5969C1.54055 20.6293 1.59683 20.649 1.65534 20.6542C1.71384 20.6594 1.77272 20.6499 1.82665 20.6267L7.99999 18.08V15.3333H9.33332V18.3533L15.3333 21.4267V18.6667H16.6667V21.1933L22.42 19.3933C22.4921 19.3705 22.5549 19.3252 22.5993 19.264C22.6437 19.2028 22.6673 19.1289 22.6667 19.0533V5.24C22.6672 5.1842 22.6544 5.12907 22.6295 5.07914C22.6046 5.0292 22.5682 4.98587 22.5234 4.9527C22.4785 4.91953 22.4264 4.89747 22.3713 4.88831C22.3163 4.87915 22.2599 4.88315 22.2067 4.9ZM9.33332 14H7.99999V11.3333H9.33332V14ZM9.33332 10H7.99999V7.33334H9.33332V10ZM16.6667 17.3333H15.3333V14.6667H16.6667V17.3333ZM16.6667 13.3333H15.3333V10.6667H16.6667V13.3333Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityMapSolid);
export default __webpack_public_path__ + "static/media/clarity_map-solid.6fea6040c57ffd9fba83a5738e337647.svg";
export { ForwardRef as ReactComponent };